import React, { useEffect, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import Layout from '../Layout';
import { CancelModal, EditMaintenanceModal, StatContainer } from './MaintenanceComponent';
import { MaintenanceApi } from '../../app/api/maintenance.api';


export function Maintenance() 
{

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedMaintenance, setSelectedMaintenance] = useState({});

  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");
  const [month, setMonth] = useState("");
    
  const maintenance = MaintenanceApi(); 
  const [filteredData, setFilteredData] = useState([]);
  const [showResponseModal, setShowResponseModal] = useState(false);

      
  const fetchData = async () => { 
    const {data} = await maintenance.findAll();
    return data.data; 
  }
  const { isLoading, data=[], error, refetch } = useQuery({  queryKey: ["maintenances"], queryFn: fetchData });
      
      
  const handleInputs = (event) => {
      const { name, value } = event.target;
      if( name === 'category' ) {
          setCategory(value);
      }
      if( name === 'status' ) {
          setStatus(value);
      }
      if( name === 'month' ) {
          setMonth(value);
      }
  }
    
  useEffect(() => {
      
      if (!Array.isArray(data)) return;
      let filtered = data;
      
      if (status !== "") {
        filtered = filtered.filter(item => item.status.toLowerCase() === status.toLowerCase());
      }
      
      if (category !== "") {
        filtered = filtered.filter(item =>
          item.type.toLowerCase() === category.toLowerCase()
        );
      }
      // Filtre mois (format YYYY-MM)
      if (month !== "") {
        filtered = filtered.filter(item =>
          item.createdAt?.startsWith(month)
        );
      }
         
      setFilteredData(filtered);
      
  }, [data, category, status, month]);  
    
  

  //Gestion modals

  const handleEdit = ( maintenance ) => {
    setSelectedMaintenance( maintenance );
    setShowEditModal(true);
  };

  const handleOpenCancelModal = (maintenance) => {
     setSelectedMaintenance( maintenance );
     setShowResponseModal(true);
  };


  return (

    <Layout activeMenu={3}>
  
      <div className='container-fluid m-0 bg-white py-5'>
        <div className='row justify-content-center'>
          <div className='col-md-11'>

            <section className='row'>
              <div className='col-12 px-0'>
                 <div className="d-flex flex-column">

                    {/* Vue Grille/Liste */}
                    <div className="d-flex align-items-center gap-3 display-controls mb-3">
                      <span className="text-muted lead"><i className="bi bi-grid"></i></span>
                      <span className="text-muted lead"> Statistique maintenance </span>
                    </div>

                    {/* Cartes de Statistiques */}
                    <StatContainer />

                    {/* Barre de Filtres et Contrôles */}
                    <div className="row mt-5">
                      <div className="d-flex gap-3 flex-column flex-md-row justify-content-between align-items-center border-bottom pb-3 mb-4">
                        {/* Vue Grille/Liste */}
                        <div className="d-flex align-items-center gap-3 display-controls">
                          <span className="text-muted lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                          <span className="text-muted lead"> Liste des maintenances </span>
                        </div>
                        {/* Infos et Tris */}
                        <div className="d-flex align-items-center gap-3 filter-controls">
                           <span className="text-muted small"> { filteredData.length } effectif(s) </span>
                        </div>
                      </div>

                      {/* Boutons de Filtres Catégories */}
                      <div className="d-flex gap-2 flex-wrap mb-5">
                        <div className="dropdown">
                          <select className="w-100 text-muted px-3 py-1 border" value={category} name="category" onChange={ handleInputs } >
                            <option value="" > Sélectionner catégorie </option>
                            <option value="biomedicale" > Biomédicale </option>
                            <option value="informatique" > Informatique </option>
                            <option value="autres" > Autres maintenances </option>
                          </select>
                        </div>
                        <div className="dropdown">
                          <select className="w-100 text-muted px-3 py-1 border" value={status} name="status" onChange={ handleInputs } >
                            <option value="" > Sélectionner le status </option>
                            <option value="pending"> En cours </option>
                            <option value="done"> Livré </option>
                            <option value="canceled"> Annulé </option>
                          </select>
                        </div>
                        <div className="d-flex align-items-center">
                          <input type="month" className="w-100 px-3 py-1 border" value={month} name="month" onChange={ handleInputs } />                        
                        </div>
                      </div>

                    </div>
                  </div>
               </div>
            </section>

            <section className="row">

              {/* Loading */}
              {isLoading && (
                <div className="d-flex flex-column align-items-center mt-4">
                  <div className="spinner-border mb-3" style={{ width: '5rem', height: '5rem', color: '#307072' }}></div>
                  <p className="text-secondary"> Chargement de données en cours...</p>
                </div>
              )}
              
              {/* Error */}
              {!isLoading && error && (
               <div className="text-center p-4 border alert alert-danger w-100">
                 Une erreur est survenue. Veuillez vérifier votre connexion.
               </div>
              )}
              
              {/* Data */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length > 0 && (

                filteredData.map( ( item, index ) => (

                    <div className="col-lg-12 px-0" key={index}>
                        <div className="d-flex gap-3 p-3 flex-column flex-lg-row justify-content-between border mb-3">
                          <div className="d-flex align-items-center">
                            {
                              item?.status === 'pending' && ( 
                                <div className="d-flex align-items-center justify-content-center text-secondary me-3 p-2 alert alert-warning mb-0" title="Opération de maintenance en cours">
                                  <i className="bi bi-tools fs-2"> </i> 
                                </div>
                              )
                            }
                            {
                              item?.status === 'done' && ( 
                                <div className="d-flex align-items-center justify-content-center text-secondary me-3 p-2 alert alert-success mb-0" title="Opération de maintenance achevée">
                                  <i className="bi bi-tools fs-2"> </i> 
                                </div>
                              )
                            }
                            {
                              item?.status === 'canceled' && ( 
                                <div className="d-flex align-items-center justify-content-center text-secondary me-3 p-2 alert alert-danger mb-0" title="Opération de maintenance annulée">
                                  <i className="bi bi-tools fs-2"> </i> 
                                </div>
                              )
                            }
                            <div>
                              <div className="d-flex align-items-center text-secondary small gap-2" title={ 'Type de maintenance' }>
                                <span className="fw-bold"> Maintenance : { item?.type } </span>                            
                              </div>
                              <div className="text-secondary small" title={ 'sous type de maintenance' }> Catégorie : { item?.subtype } </div>
                              <div className="fw-bold text-secondary small" title={ 'Numéro joignable' }> Numéro tel : { item?.phone } </div>
                              <div className="text-secondary small" title={ 'date' }> { item?.date } à { item?.time } </div>
                              {
                                  item?.status === 'done' && (
                                    <div className="d-flex flex-column gap-2">
                                      <span className="bg-light border text-green small" title="Email admin"> Admin : { item?.admin }  </span>
                                      <span className="bg-light border text-muted fw-bold py-1 px-2" title="Montant payé"> Montant : { item?.price } Fcfa  </span>
                                    </div> )
                              }
                              {
                                  item?.status === 'canceled' && ( <span className="bg-light border text-danger small" title="Email admin"> Admin : { item?.admin }  </span> )
                              }   
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-3">

                            {/* STATUS PENDING → afficher les deux boutons */}
                            { 
                              item.status === "pending" && (
                                <>
                                  <button title="Annuler maintenance" className="btn btn-sm rounded-0 btn-outline-danger px-2 mt-2" onClick={() => handleOpenCancelModal(item)}>
                                    Annuler
                                  </button>
                                  <button title="Valider maintenance" className="btn btn-sm rounded-0 btn-outline-green px-2 mt-2" onClick={() => handleEdit(item)} >
                                    Valider <i className="bi bi-check-circle"></i>
                                  </button>
                                </>
                              )
                            }
                           </div> 
                        </div>
                    </div>
                  ))
              )} 
              
              {/* Liste vide */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length === 0 && (
                <div className="bg-white border p-4 text-center text-secondary w-100">
                  La liste est actuellement vide. Aucun élément n’a été trouvé.
                </div>
              )}
              
            </section>
                
          </div>   
        </div>
      </div>


      {/* Confirmation popup */}
      <CancelModal show={showResponseModal} onHide={() => setShowResponseModal(false)} maintenance={ selectedMaintenance } refetch={refetch} />

      {/* Modal de Modification d'utilisateur */}
      <EditMaintenanceModal show={showEditModal} onHide={() => setShowEditModal(false)} maintenance={ selectedMaintenance } refetch={refetch} />
        

    </Layout>

  );
        
}